import { CSSResultGroup, TemplateResult, html, nothing } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './se-results-teaser.css.lit';
import { SlotController } from '../../controllers/slot-controller';
import { MobileController } from '../../controllers/mobile-controller';

/**
 * The SeResultsTeaser component
 * @element se-results-teaser
 * @slot image - optional img
 */
@customElement('se-results-teaser')
export class SeResultsTeaser extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  mobileController = new MobileController(this);
  slots: SlotController = new SlotController(this, true);

  /**
   * String representing the type 'professional', 'event', etc.
   */
  @property({ type: String })
  type: string;

  /**
   * Text for title/link
   */
  @property({ type: String, attribute: 'link-text' })
  linkText: string;

  /**
   * link href
   */
  @property({ type: String, attribute: 'link-href' })
  linkHref: string;

  /**
   * optional date
   */
  @property({ type: String })
  date: string;

  /**
   * optional employee job title
   */
  @property({ type: String })
  position: string;

  /**
   * main body text
   */
  @property({ type: String })
  summary: string;

  /**
   * whether the image slot has content.
   */
  @property({ type: Boolean })
  hasImage: boolean;

  render(): TemplateResult {
    return html` <section class="se-result-teaser">
      ${this.mobileController.isXl ? nothing : this.imageSlot()}
      <div class="se-result-teaser--content">
        <span class="se-result-teaser--type">${this.type}</span>
        <se-link class="se-result-teaser--link" link-href="${this.linkHref}"
          >${this.linkText}</se-link
        >
        ${this.date && this.date !== ''
          ? html`<span class="se-result-teaser--date">${this.date}</span>`
          : null}
        ${this.position && this.position !== ''
          ? html`<span class="se-result-teaser--position"
              >${this.position}</span
            >`
          : null}
        <p class="se-result-teaser--summary">${this.summary}</p>
        <slot></slot>
      </div>
      ${this.mobileController.isXl ? this.imageSlot() : nothing}
    </section>`;
  }

  firstUpdated() {
    this.hasImage = this.slots.test('image');
  }

  imageSlot() {
    if (this.hasImage) {
      return html`<slot name="image"></slot>`;
    } else {
      return null;
    }
  }
}
